import React from "react"
import { cn } from "../lib/utils"

export function PageHeader({ context, title, description, actions, className }) {
  return (
    <header className={cn("w-full", className)}>
      <div className="rounded-xl border border-border/80 bg-card px-5 py-4 shadow-sm md:px-6 md:py-5">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="min-w-0 flex-1 space-y-1.5">
            {context ? (
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{context}</p>
            ) : null}
            <h1 className="text-xl font-semibold tracking-tight text-foreground">{title}</h1>
            {description ? (
              <p className="max-w-3xl pt-0.5 text-sm leading-relaxed text-muted-foreground">{description}</p>
            ) : null}
          </div>
          {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      </div>
    </header>
  )
}
